import React from 'react';
import PropTypes from 'prop-types';

import {
  injectIntl,
} from 'components';

export const NoPermission = ({ formatMessage, history: { location: { hash } } }) => {
  const [key, page] = hash.split('#')[1].split('=');
  return (
    <div>
      <h1>{key === 'page' ? `${formatMessage(page)} - ` : ''}{formatMessage('Not Allowed')}</h1>
      <h2>
        {formatMessage('You are not allowed to view this page. Please ask your administrator read/write access to this page.')}
      </h2>
    </div>
  );
};

NoPermission.propTypes = {
  history: PropTypes.shape({}).isRequired,
  formatMessage: PropTypes.func.isRequired,
};

export default injectIntl(NoPermission);
